import { DbImage } from "./DbImage";
import { PermissionType } from "./Permission/PermissionType";
import {PlayListType} from "./PlayListType";
import {BaseGame} from "./Game/BaseGame";
import {TempAccount} from "../store/Account";

export function accountHasAnyPermission(account: AccountType|TempAccount|null|undefined, permissionsToCheck: PermissionType[]): boolean{
    // noinspection PointlessBooleanExpressionJS
    return !!(
        account &&
        !isTempAccount(account) &&
        account.permissions &&
        account.permissions.some(p => permissionsToCheck.includes(p))
    );
}
export function isAccountType(arg: AccountType|TempAccount|null|undefined): arg is AccountType {
    return arg !== undefined &&
        arg !== null &&
        arg.id !== undefined &&
        'email' in arg &&
        'wallAcceptedEulaVersion' in arg;
}
export function isTempAccount(account: TempAccount | AccountType): account is TempAccount{
    return 'loading' in account;
}

export function getFullName(account: TempAccount | AccountType | undefined){
    return account && !isTempAccount(account) ?
        `${account.firstname || ''}${account.lastname ? ` ${account.lastname}` : ''}` :
        ''
}

export function accountIsAdmin(account?: TempAccount|AccountType|null){
    // noinspection PointlessBooleanExpressionJS
    return !!(
        account &&
        !isTempAccount(account) &&
        account.permissions &&
        account.permissions.includes("Admin")
    );
}

export function accountIsChildAllowed(account?: TempAccount|AccountType|null){
    return (
        accountIsAdmin(account) ||
        accountHasAnyPermission(account, ["ChildOrganizations"])
    );
}

export function accountIsAuthor(account?: TempAccount|AccountType|null, item?: PlayListType|BaseGame|null): boolean{
    // noinspection PointlessBooleanExpressionJS
    return !!(
        account &&
        item &&
        item.authorIds &&
        item.authorIds.includes(account.id)
    );
}

export function accountIsOwner(account?: TempAccount|AccountType|null, item?: PlayListType|BaseGame|null): boolean{
    // noinspection PointlessBooleanExpressionJS
    return !!(
        account &&
        item &&
        item.ownerId === account.id
    );
}

export interface AccountType {
    id: string;
    email: string;
    firstname: string;
    lastname: string;
    description: string;
    profileImage: DbImage;
    organizationId: string;
    permissions: null | PermissionType[];
    language: string;
    isPublic: boolean;
    wallAcceptedEulaVersion: string;
    followings: string[];
    PlayListFollowings: string[];
    FavoriteGames: string[];
}